import * as ng from 'angular';
import { UibDatepickerPopup } from './uib-datepicker-popup.directive';


export const UibDatepickerPopupModule: string =
    ng.module('uib-datepicker-popup', [
    ])
        .directive('uibDatepickerPopup', UibDatepickerPopup)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uib-datepicker-popup/uib-datepicker-popup.module.ts